import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { StateLocation } from '../types';

const initialState: StateLocation = {
  centers: [],
  currentLocation: {
    garId: 1405113,
    name: 'Москва',
    fullName: 'г Москва',
    nameLocative: 'в Москве',
    nameGenitive: 'Москвы',
    route: '6.83.',
    alias: 'moskva',
    localityType: 'город',
    shortLocationType: 'г.',
    latitude: 55.753676,
    longitude: 37.619899,
    routeGar: '1405113',
    regionRoute: '6.83.',
    fias: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
    id: 83,
    fullNameShortened: 'г. Москва',
    country: 'russia',
  },
};

export const locationSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setCurrentLocation: (state, { payload }: PayloadAction<ILocationV2>) => {
      state.currentLocation = payload;
    },
    setLocations: (state, { payload }: PayloadAction<ILocationV2[]>) => {
      state.centers = payload;
    },
  },
});

export const { setCurrentLocation, setLocations } = locationSlice.actions;
